import { apiClient } from "../common/axiosInstance";

export const getAllRoles = async () => {
  const response = await apiClient.get("/roles");

  return response.data;
}